const STEP_1_CART = 1;
const STEP_2_LOGIN = 2;
const STEP_3_DELIVERY = 3;
const STEP_4_PAYMENT = 4;

const TYPE_EXISTING = 'EXISTING';
const TYPE_NEW = 'NEW';
const TYPE_GUEST = 'GUEST';
const TYPE_AUTO = 'AUTO';

export {
  STEP_1_CART,
  STEP_2_LOGIN,
  STEP_3_DELIVERY,
  STEP_4_PAYMENT,
  TYPE_EXISTING,
  TYPE_NEW,
  TYPE_GUEST,
  TYPE_AUTO,
};



// WEBPACK FOOTER //
// ./js/common/CheckoutStepEnum.js